var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":"","loading":_vm.loading},on:{"click":_vm.submit}},[_vm._v("Create by Day")])
}
var staticRenderFns = []

export { render, staticRenderFns }